import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import {
  IFeedFormat,
  IFeedFormatAttributes,
  IFeedFormatsPayload,
  IFormatResponseCheckResponse,
  IFeedFormatsFilter
} from '@/apps/traforama/interfaces/feedFormats'

import {
  fetchItems,
  createItem,
  updateItem,
  checkItem,
  fetchItem,
  destroyItem,
  archiveItem
} from '@/apps/traforama/api/feedFormats'

import { useFeedsStore } from '@/store/modules/feeds'
import useCrudStore from '@/hooks/useCrudStore'

const defaultFilter: IFeedFormatsFilter = { disabled: false }

export const useFeedFormatsStore = defineStore('feedFormats', () => {
  const feedsStore = useFeedsStore()
  const checkedResponse = ref<any>({})

  const {
    currentItems,
    total,
    filter,
    selected,
    closed,
    items,
    listLoading,
    itemsLoading,
    currentPage,
    error,
    itemById,
    payload,

    ToggleSelection,
    FetchItem,
    DestroyItem,
    SaveItem,
    SetFilters,
    SetCurrentPage,
    SetLimit,
    ToggleClose,

    setItems,
    setCurrentItems,
    setTotal
  } = useCrudStore({
    defaultFilter,
    fetchItem,
    createItem,
    updateItem,
    destroyItem
  })

  const Archive = async (id: string) => {
    await archiveItem(id)
    currentItems.value = currentItems.value.filter((item) => item.id !== id)
  }

  // Check the response of a feed format
  const CheckResponse = async (
    feedFormat: IFeedFormatAttributes | undefined
  ) => {
    if (feedFormat === undefined) return
    const response = await checkItem(feedFormat)
    setCheckedResponse(response)
  }

  const FetchItems = async (
    currentPayload: undefined | IFeedFormatsPayload = undefined
  ) => {
    currentPayload = currentPayload || payload.value
    listLoading.value = true
    error.value = null
    try {
      const response = await fetchItems(currentPayload)
      setItems(response.data)
      setCurrentItems(response.data)
      setTotal(response.meta.total)
      feedsStore.SetItems(response.included)
    } catch (e: any) {
      error.value = e.toString()
    } finally {
      listLoading.value = false
      error.value = null
    }
  }

  const setCheckedResponse = (item: IFormatResponseCheckResponse) => {
    checkedResponse.value = item
  }

  return {
    // State
    items,
    selected,
    closed,
    currentItems,
    checkedResponse,
    defaultFilter,
    filter,
    listLoading,

    // Actions
    Archive,
    CheckResponse,
    FetchItems,
    SaveItem,
    FetchItem,
    ToggleClose,
    DestroyItem,
    SetFilters,
    SetCurrentPage,
    SetLimit,
    // Getters
    itemById
  }
})
